import script from "./CheckoutPixPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutPixPayment.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutPixPayment.vue?vue&type=style&index=0&id=f4a20b70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4a20b70"]])

export default __exports__